import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import img1 from "../assets/img/home/uniqueAtCutis/4dfacelift.jpg";
import img2 from "../assets/img/home/uniqueAtCutis/Multi_Laser_hair_reduction.png";
import img3 from "../assets/img/home/uniqueAtCutis/Tatoo_removal.png";
import img4 from "../assets/img/home/uniqueAtCutis/Vanquish_Treatment.png";
const Unique = () => {
  const uniqueAtCutis = [
    {
      id: 1,
      image: `${img1}`,
      links: "/service/laser-hair-reduction",
      title: "Multi Laser Hair Reduction",
      description:
        "CACS provides comprehensive hair care and four types of laser technology like Advance IPL (Ellipse),  Alexandrite (Clarity), Nd:YAG (Fotona) and Diode laser (Lumenis) systems.",
      alt: "Multi Laser hair reduction",
    },
    {
      id: 2,
      image: `${img2}`,
      links: "/service/4d-facelift",
      title: "4D Facelift",
      description:
        "4D Facelift is an innovative laser treatment to treat four dimensions of skin and to rejuvenate and tighten it from the inside-out.",
      alt: "",
    },
    {
      id: 3,
      image: `${img3}`,
      links: "/service/lasers",
      title: "Tattoo removal (Pico Laser)",
      description:
        "The first center to have Pico Laser in South India, to remove a multi-color tattoo, where the outcome is twice the speed of conventional lasers.",
      alt: "",
    },
    {
      id: 4,
      image: `${img4}`,
      links: "/service/body-shaping",
      title: "Vanquish Treatment (Body Shaping)",
      description:
        "Well-known treatment for contouring, contactless and painless procedure that helps to contour your stubborn fats.",
      alt: "",
    },
    {
      id: 5,
      image: `${img1}`,
      links: "/service/laser-hair-reduction",
      title: "Multi Laser Hair Reduction",
      description:
        "CACS provides comprehensive hair care and four types of laser technology like Advance IPL (Ellipse),  Alexandrite (Clarity), Nd:YAG (Fotona) and Diode laser (Lumenis) systems.",
      alt: "facelift",
    },
    {
      id: 6,
      image: `${img2}`,
      links: "/service/4d-facelift",
      title: "4D Facelift",
      description:
        "4D Facelift is an innovative laser treatment to treat four dimensions of skin and to rejuvenate and tighten it from the inside-out.",
      alt: "",
    },
    {
      id: 7,
      image: `${img3}`,
      links: "/service/lasers",
      title: "Tattoo removal (Pico Laser)",
      description:
        "The first center to have Pico Laser in South India, to remove a multi-color tattoo, where the outcome is twice the speed of conventional lasers.",
      alt: "",
    },
    {
      id: 8,
      image: `${img4}`,
      links: "/service/body-shaping",
      title: "Vanquish Treatment (Body Shaping)",
      description:
        "Well-known treatment for contouring, contactless and painless procedure that helps to contour your stubborn fats.",
      alt: "",
    },
  ];
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    cseEase: "linear",
    lazyLoad: true,
    loop: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    swipeToSlide: true,
  };
  return (
    <>
      <div
        className="container my-3 my-sm-5"
        id="trending_services_home"
        data-aos="fade-up"
      >
        <div className="need-heading">
          <h2 className="text-center text-til my-3">UNIQUE AT CUTIS</h2>
        </div>
        <div className="row" data-aos="fade-up">
          <div className="col">
            <Slider {...settings}>
              {uniqueAtCutis.map((value, index) => (
                <div className="m-service-card" key={index}>
                  <Link
                    to={value.links}
                    className="myCutomLinkCSS"
                    target="_blank"
                  >
                    <div className="m-service-box p-3 text-center card">
                      <div className="m-service-img u-service-img">
                        <img src={value.image} alt="" />
                      </div>
                      <div className="m-service-content unique-service-content">
                        <h3 className="text-center my-2">{value.title}</h3>
                        <p>{value.description}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default Unique;
